import { Alert, Snackbar, Typography } from "@mui/material";
import React, { useCallback, useRef, useState } from "react";
import "../../tug/testModuleInfoPage.scss";
import tugSide from "../../../../../assets/images/tugSide.png";
import forwardArrow from "../../../../../assets/images/forwardArrow.svg";
import viewReport from "../../../../../assets/images/viewReport.svg";
import UserDetailsHeader from "../../../UserDetailsHeader";
import { useDispatch } from "react-redux";
import { HOW_TO_TEST_TUG_SIDE } from "../../../../../routes/routerPath";
import { getParams, searchParams } from "../../../../../utlis/helpers";
import { useNavigate } from "react-router-dom";
import { setVideoFile } from "../../../../../state/actions/videoUploadAction";
import { infoPageItem } from "../../../../../utlis/constants";
import FileUpload from "../../videoSaved/FileUpload";
import { pageLocale } from "../../../../../utlis/locale";
import VideoRecorder from "../../../../videoRecorder/VideoRecorder";
import RecordUploadChoice from "../../../../modals/RecordUploadChoice";
import { rewriteReportDomain } from "../../../../../configs/environment";
import {
  MAX_VIDEO_DURATION_SECONDS,
  validateCapturedVideo,
  validateUploadedVideo,
} from "../../videoUploadValidation";

const TugSide = () => {
  const videoRef = useRef();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { accessToken, providerId, adminId, clientId } = getParams();
  const [showItem, setShowItem] = useState(true);
  const [showChoiceModal, setShowChoiceModal] = useState(false);
  const [showRecorder, setShowRecorder] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("error");
  const storedTest = JSON.parse(sessionStorage.getItem("testMModule"));
  const getTestDetails = storedTest.find((e) => e.moduleId === 1);
  const getInfo = JSON.parse(sessionStorage.getItem("testDescription"));
  const { how_to_test, view_report, record_upload } = pageLocale("testinfo");
  const { testUploadAlert } = pageLocale("common");
  const videoUploadText = pageLocale("videoUpload");
  const itemList = [...infoPageItem];
  if (getTestDetails?.isReportAvailable) {
    itemList.splice(1, 0, {
      icon: viewReport,
      title: view_report,
    });
  }
  const videoHandler = (title) => {
    if (title === how_to_test) {
      navigate(HOW_TO_TEST_TUG_SIDE + `${searchParams}`);
    }
    if (title === view_report) {
      const reportUrl = rewriteReportDomain(
        (getTestDetails?.reportURL || "").replace(
          /side-tug-reportv1/g,
          "side-tug-reportv2",
        ),
      );
      window.location.href = `${reportUrl}&isWebsite=true&accessToken=${accessToken}&providerId=${providerId}&adminId=${adminId}&clientId=${clientId}`;
    }
  };

  const videoPickHandler = () => {
    sessionStorage.setItem("fromUpload", JSON.stringify(getTestDetails));
    setShowChoiceModal(true);
  };

  const handleRecord = () => {
    setShowChoiceModal(false);
    setShowRecorder(true);
  };

  const handleUpload = () => {
    setShowChoiceModal(false);
    videoRef.current.click();
  };

  const showUploadToast = useCallback((message) => {
    setSnackbarMessage(message);
    setSnackbarSeverity("error");
    setSnackbarOpen(true);
  }, []);

  const handleRecordingComplete = async (file) => {
    const validation = await validateCapturedVideo(file, {
      preferredOrientation: "landscape",
    });
    if (!validation.valid) {
      const validationMessage =
        validation.error === "orientation"
          ? videoUploadText.capture_validation_landscape
          : validation.error === "metadata"
            ? videoUploadText.capture_validation_metadata
            : videoUploadText.validation_duration;

      return {
        valid: false,
        message: validationMessage,
      };
    }

    dispatch(setVideoFile(file));
    setShowRecorder(false);
    setShowItem(false);
    return { valid: true };
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    event.target.value = "";
    if (!file) return;

    const validation = await validateUploadedVideo(file);
    if (!validation.valid) {
      const messageKey = `validation_${validation.error}`;
      showUploadToast(videoUploadText[messageKey]);
      return;
    }

    dispatch(setVideoFile(file));
    setShowItem(false);
  };
  return (
    <>
      {showRecorder && (
        <VideoRecorder
          onRecordingComplete={handleRecordingComplete}
          onCancel={() => setShowRecorder(false)}
          facingMode="environment"
          maxDuration={MAX_VIDEO_DURATION_SECONDS}
          preferredOrientation="landscape"
        />
      )}

      <RecordUploadChoice
        open={showChoiceModal}
        onClose={() => setShowChoiceModal(false)}
        onRecord={handleRecord}
        onUpload={handleUpload}
      />

      <UserDetailsHeader>
        {showItem ? (
          <div className="tug-test-info-wrapper">
            <Typography className="title">{getInfo?.moduleName}</Typography>
            <div className="tug-module-box">
              <div className="tug-module-subbox">
                <img
                  src={tugSide}
                  alt="tug-side"
                  className="test-img side-img"
                />
                <Typography className="test-description">
                  {getInfo?.description}
                </Typography>
                {itemList.map((item, index) => {
                  return (
                    <div
                      className="item-wrapper"
                      key={index}
                      onClick={() => videoHandler(item.title)}
                    >
                      <div className="item-name">
                        <img src={item.icon} alt="info" className="img" />
                        <Typography>{item.title}</Typography>
                      </div>
                      <div className="arrow">
                        <img src={forwardArrow} alt="forwardArrow" />
                      </div>
                    </div>
                  );
                })}
                <input
                  type="file"
                  accept=".mp4,.mov,video/mp4,video/quicktime"
                  ref={videoRef}
                  className="video-upload"
                  onChange={handleFileChange}
                />
                <div className="important-text">
                  <Typography
                    className="sub-info"
                    component="div"
                    dangerouslySetInnerHTML={{ __html: testUploadAlert }}
                  />
                </div>
                <div className="record-upload-btn">
                  <button className="button" onClick={() => videoPickHandler()}>
                    {record_upload}
                  </button>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <FileUpload />
        )}
      </UserDetailsHeader>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbarOpen(false)}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default TugSide;
